function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var _ref2 =
/*#__PURE__*/
/*#__PURE__*/
React.createElement("path", {
  fill: "none",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "M9.694 3.62c1.122-1.087 1.683-1.63 2.37-1.62c.686.01 1.23.572 2.316 1.694c1.087 1.122 1.63 1.683 1.62 2.37c-.011.686-.572 1.229-1.694 2.316s-1.683 1.63-2.37 1.62c-.686-.011-1.23-.572-2.316-1.694C8.533 7.184 7.99 6.623 8 5.936c.011-.686.572-1.23 1.694-2.316M7 13.5a2.5 2.5 0 1 1-5 0a2.5 2.5 0 0 1 5 0m15 0a2.5 2.5 0 1 0-5 0a2.5 2.5 0 0 0 5 0M12 10v7M9.5 8.5l-3 3m8-3l3 3m-8 7.9c0-1.131 0-1.697.351-2.049C10.203 17 10.77 17 11.9 17h.2c1.131 0 1.697 0 2.049.351c.351.352.351.918.351 2.049v.2c0 1.131 0 1.697-.351 2.048C13.797 22 13.23 22 12.1 22h-.2c-1.131 0-1.697 0-2.049-.352c-.351-.351-.351-.917-.351-2.048z",
  color: "currentColor"
});
const SvgWorkflow = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), _ref2);
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgWorkflow, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/workflow.42d472e8.svg";
export { ForwardRef as ReactComponent };